export enum PaymentStatus {
  PURCHASED = 'PURCHASED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  ACTIVE = 'ACTIVE',
  INSUFFICIENT_AMOUNT = 'INSUFFICIENT_AMOUNT',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

export enum PaymentMethodType {
  CARD = 'CARD',
  ACSS_DEBIT = 'ACSS_DEBIT',
  PLAID_BANK_TRANSFER = 'PLAID_BANK_TRANSFER',
  SEPA_DEBIT = 'SEPA_DEBIT',
}
